import './paedml-card.tag'
import './paedml-modal-createoredit-admin.tag'
import './paedml-modal-delete.tag'
import './paedml-icon.tag'
import './paedml-icon-modal.tag'
import './paedml-modal-init-import.tag'
import './paedml-modal-edit-import.tag'
import './paedml-modal-hinweis-schulart.tag'
import './paedml-modal-edit-versetzung.tag'
import './paedml-modal-reset-versetzung.tag'
import './paedml-modal-freigabe-versetzung.tag'

<paedml-card-versetzung-klassen>
  <paedml-card config={opts.config} perm={opts.perm} siblings={opts.siblings} ref='card'>

    <virtual if="{active}">
      <span class="btn paedml" onclick={parent.handleRefresh}>
        <paedml-icon icon="aktualisieren"  title="Synchronisieren" type="zoom" />
      </span>
    </virtual>

    <virtual if="{selectedExactlyOne() && parent.canRelocate(getSelectedRows)}">
      <paedml-icon-modal icon="fas-arrows-alt-v" target="#{prefix}-relocation-modal" title={parent.opnameVersetzung} />
      <paedml-modal-edit-versetzung prefix="{prefix}-relocation" mode={parent.mode} variant="klassen" selectedrowsfunc={getSelectedRows}
        heading="{config.contentTitle}: {parent.opnameVersetzung}" opname={parent.opnameVersetzung} api={restApi}
        patient="{{singular: 'Klasse', plural: 'Klassen'}}"
        idcol="0" idtextcol="1"
      />
    </virtual>
  </paedml-card>

  <script>
    import store from '../store'
    import { client } from '../util/api-util'
    import * as mapper from '../mapper'
    import * as R from 'ramda'
    import Session from '../store/session'
    import Masterdata from '../config/masterdata'

    this.mode = this.config.custom.mode
    this.opnameVersetzung = 'Versetzung der Klassen aufbereiten'
    this.edit = this.opts.edit ? true : false
    this.data = {}
    this.api = this.opts.api
    this.session = Session

    this.handleRefresh = e => {
      this.refs['card'].trigger('reloadTable')
    }

    this.schoolTypeExists = () => R.keys(Session.lut.schularten).length > 0

    this.updateRelAST = () => {
      const {settings} = Session
      const {schularten} = Session.map
      const relAST = {}
      R.forEachObjIndexed((v,k) => {
        const tmp = settings[k].isRelocationModeActive
        if (tmp === 'true' || tmp === 'True' || tmp === true) {
          relAST[v] = true
        }
      }, schularten)
      this.relAST = relAST
    }

    this.canRelocate = (selectedrowsfunc) => {
      this.updateRelAST()
      const selectedRows = selectedrowsfunc()
      for (let i = 0; i < selectedRows.length; ++i) {
        if (!this.relAST[selectedRows[i][2]]) return false
      }
      return true
    }

    this.hasNoErrorOrWarning = (selectedrowsfunc) => {
      const selectedRows = selectedrowsfunc()
      for (let i=0; i < selectedRows.length; ++i) {
        if (selectedRows[i][0] !== '') return false
      }
      return true
    }
  </script>
</paedml-card-versetzung-klassen>
